export const ADD_TRANSLATION = 'phraseTRForm/ADD_TRANSLATION';
export const CHANGE_TRANSLATION = 'phraseTRForm/CHANGE_TRANSLATION';
export const SAVE_BUTTON_CLICK = 'phraseTRForm/SAVE_BUTTON_CLICK';
export const LOAD_FORM = 'phraseTRForm/LOAD_FORM';
export const DELETE_BUTTON_CLICK = 'phraseTRForm/DELETE_BUTTON_CLICK';
